/**
 * 获取url的参数
 * @param {name} 想获取的url参数名称
 */
export const getUrlCode = name => {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
};

/**
 * 获取截取去掉指定参数的地址
 */
export const getHref = (...arg) => {
  //跳转地址
  let param = Array.from(arg);
  let location = window.location;
  let search = location.search;
  console.log(search);
  if (search) {
    search = search.substr(1);
  }
  let href = location.origin;
  console.log(href);
  let pathName = location.pathname;
  console.log(pathName);
  if (pathName) {
    href += pathName;
  }
  let searchArr = search.split("&").filter(item => {
    let flag = true;
    param.forEach(v => {
      if (item.indexOf(v + "=") !== -1) {
        flag = false;
      }
    });
    return flag;
  });
  if (searchArr.length > 0) {
    href += "?" + searchArr.join("&");
  }
  let hash = location.hash;
  if (hash) {
    href += hash;
  }
  return href
};



// WEBPACK FOOTER //
// ./src/util/index.js